<template>
  <div>
    <el-input readonly type="text" style="width:400px;" v-model="order.order_no" placeholder="请选择订单"
      @click.native="handleShowSelected">
      <el-button class="blue" type="primary" style slot="append">请选择</el-button>
    </el-input>
    <el-dialog width="800px" append-to-body :close-on-click-modal="false" class="modal-dialog no-padding-modal"
      title="选择订单" :visible.sync="showSelectForm" :before-close="handleClose">
      <div class="page-link-box">
        <el-input prefix-icon="el-icon-search" clearable size="mini" style="width: 250px" placeholder="请输入订单号"
          @keyup.enter.native="handleFilter" @clear="handleFilter" v-model="listQuery.keyword"></el-input>
        <el-button class="mgl10" type="primary" :loading="loading" size="mini" v-waves icon="el-icon-search"
          @click="handleFilter">搜索</el-button>

        <el-table class="mgt10" :data="list" size="mini" v-loading="loading" element-loading-text="给我一点时间"
          :empty-text="emptyText" border fit highlight-current-row style="width: 100%;">
          <el-table-column width="80" align="center" label="ID">
            <template slot-scope="scope">
              <span>{{ scope.row.id }}</span>
            </template>
          </el-table-column>
          <el-table-column minWidth="150" align="center" label="订单号">
            <template slot-scope="scope">
              <span>{{ scope.row.order_no }}</span>
            </template>
          </el-table-column>
          <el-table-column minWidth="150" align="center" label="订单描述">
            <template slot-scope="scope">
              <span>{{ scope.row.product[0].name }}</span>
            </template>
          </el-table-column>
          <el-table-column minWidth="150" align="center" label="订单状态">
            <template slot-scope="scope">
              <span>{{ scope.row.status_name }}</span>
            </template>
          </el-table-column>
          <el-table-column width="150" align="center" label="下单时间">
            <template slot-scope="scope">
              <span>{{ scope.row.create_time }}</span>
            </template>
          </el-table-column>
          <el-table-column width="100" align="center" label="操作" fixed="right">
            <template slot-scope="scope">
              <el-button v-waves type="primary" size="mini" @click="handleSelectOrder(scope.row)">使用</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination-container">
          <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="listQuery.page" :page-sizes="[10, 20, 30, 50]" :page-size="listQuery.pagesize"
            layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import { getOrderList } from '@/api/order'
import waves from '@/directive/waves' // 水波纹指令

export default {
  name: 'OrderSelect',
  components: {

  },
  directives: {
    waves
  },
  props: {
    value: {
      type: Object,
      default: {}
    },
    productId: {
      type: Number | String,
      default: 0
    }
  },
  model: {
    event: 'change'
  },
  watch: {
    order(value) {
      this.$emit('change', value)
    },
    value(value) {
      this.order = this.value
    },
    showSelectForm(val) {
      if (val) {
        this.listQuery = {
          keyword: null,
          page: 1,
          pagesize: 10
        }
        this.total = 0
        this.list = null
      }
    }
  },
  data() {
    return {
      emptyText: '暂无订单',
      list: null,
      total: 0,
      loading: false,
      areaList: [],
      listQuery: {
        keyword: null,
        page: 1,
        pagesize: 10
      },
      order: {},
      showSelectForm: false
    }
  },
  created() {
    this.order = this.value
  },
  methods: {
    getList() {
      this.loading = true
      const _listQuery = Object.assign({}, this.listQuery)
      _listQuery.product_id = this.productId
      getOrderList(_listQuery).then(response => {
        this.loading = false
        this.list = response.data.list
        this.total = response.data.count * 1
      }).catch(() => {
        this.loading = false
      })
    },
    // 显示模态框
    handleShowSelected() {
      this.getList()
      this.showSelectForm = true
    },
    handleSelectOrder(item) {
      this.order = {
        id: item.id,
        order_no: item.order_no
      }
      this.handleClose()
    },
    handleClose() {
      this.listQuery = {
        keyword: null,
        page: 1,
        pagesize: 10
      }
      this.showSelectForm = false
    },
    // 查询
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    // 更改每页行数
    handleSizeChange(val) {
      this.listQuery.pagesize = val
      this.getList()
    },
    // 更改页码
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.getList()
    }
  }
}
</script>
